export default "<div\n  [innerHTML]=\"htmlContent\"\n  [style.width.px]=\"getScaledWidth()\"\n  [style.height.px]=\"getScaledHeight()\"\n></div>\n";